import { render, staticRenderFns } from "./livedesigndictionary.vue?vue&type=template&id=94c11c12&scoped=true"
import script from "./livedesigndictionary.vue?vue&type=script&lang=js"
export * from "./livedesigndictionary.vue?vue&type=script&lang=js"
import style0 from "./livedesigndictionary.vue?vue&type=style&index=0&id=94c11c12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c11c12",
  null
  
)

export default component.exports